import {
  Box,
  PopoverBody,
  PopoverContent,
  popoverVariants,
  type BoxProps,
} from "@hightouch/htui";
import type { ReactNode } from "react";

const outerSpacing = 1.5;

/**
 * Shared styles for nav popover menu items.
 */
export const NAV_POPOVER_MENU_ITEM_STYLES = {
  borderRadius: "lg",
  p: 2,
  mx: outerSpacing,
  fontWeight: "medium",
  transitionProperty: "background-color, color",
  transitionDuration: "fast",
  transitionTimingFunction: "easeOutQuad",
  _focusVisible: {
    bg: "base.background",
    outline: "none",
    boxShadow: "outline",
    zIndex: 1,
  },
};

/**
 * Replaces PopoverContent and PopoverBody with shared styles.
 */
export const NavPopoverContentAndBody = ({
  children,
  width = "240px",
  bg,
  ariaLabel,
}: {
  children: ReactNode;
  width?: BoxProps["width"];
  /** The popover's surface, for one that stands in for the nav itself. */
  bg?: BoxProps["bg"];
  /** Names the popover's dialog for screen readers, usually after its header. */
  ariaLabel?: string;
}) => {
  return (
    <PopoverContent
      aria-label={ariaLabel}
      // The htui menu's border, radius, and shadow, so the switcher and the flyouts match the nav's menus.
      border="none"
      borderRadius="xl"
      overflow="hidden"
      boxShadow="md"
      py={outerSpacing}
      motionProps={popoverVariants}
      width={width}
      bg={bg}
    >
      <PopoverBody p={0} display="flex" flexDir="column">
        {children}
      </PopoverBody>
    </PopoverContent>
  );
};

// Set like the drill panel's header, on the rows' inset and radius.
export const PopoverHeader = ({ title }: { title: string }) => (
  <Box
    as="span"
    display="flex"
    alignItems="center"
    color="text.primary"
    fontSize="md"
    fontWeight="semibold"
    height={8}
    px={2}
    mx={1.5}
    borderRadius="lg"
  >
    {title}
  </Box>
);
